<template>
  <v-card>
    <Tabs
      v-model="tabs_model"
      @change="change_tab($event)"
      fixed-tabs
    >
      <v-tab
        v-for="(tab, key) in tabs"
        :key="key"
      >
        {{ tab }}
      </v-tab>

      <v-tabs-items
        touchless
        v-model="tabs_model"
      >
        <v-tab-item>
          <NotificationsTab :last_notifs="last_notifs" />
        </v-tab-item>
        <v-tab-item>
          <NotificationsTab :last_news="last_news" />
        </v-tab-item>
      </v-tabs-items>
    </Tabs>
  </v-card>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';
import { notifications_store, widgets_store } from '@/store';
import { Tabs } from '@/components/global';
import NotificationsTab from './NotificationsTab.vue';

const { state } = notifications_store;

@Component({
  components: {
    Tabs,
    NotificationsTab,
  },
})
export default class WidgetNotifications extends Vue {
  tabs = [
    'Информация',
    'Новости',
  ]

  tabs_model = 0;

  change_tab(event: number) {
    this.tabs_model = event;
    widgets_store.mutations.UPD_NOTIFICATION_WIDGET_TAB_MODEL(event);

    if (event === 1) {
      notifications_store.actions.get_last_news();
    } else {
      notifications_store.actions.get_last_notifs(true);
    }
  }

  get last_notifs() {
    return state.last_notifs_is_without_news.slice(0, 5);
  }

  get last_news() {
    return state.last_news.slice(0, 5);
  }
}

</script>

<style module lang="scss">
</style>
